import { render } from "./NuovoAtleta.vue?vue&type=template&id=cf764c34&scoped=true"
import script from "./NuovoAtleta.vue?vue&type=script&lang=js"
export * from "./NuovoAtleta.vue?vue&type=script&lang=js"

import "./NuovoAtleta.vue?vue&type=style&index=0&id=cf764c34&lang=css"
import "./NuovoAtleta.vue?vue&type=style&index=1&id=cf764c34&scoped=true&lang=css"

import exportComponent from "/var/www/html/levante_web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cf764c34"]])

export default __exports__